;(function () {
    'use strict'

    var root
    var isNode
    if (typeof module !== 'undefined' && module.exports) {
        isNode = true
        root = global
    } else {
        isNode = false
        root = window
    }
    
    function GameNavigation(_, ioc, getCachedSchemeSettings, getParameterByName, history) {
        let settings = getCachedSchemeSettings()
        let idleTimeoutTimer

        this.doRedirect =  (redirectData) => {
            if(idleTimeoutTimer) clearTimeout(idleTimeoutTimer)

            history.push({
                pathname: '/' + redirectData.redirect,
                search: '',
                state: {
                    redirectData: redirectData,
                    ioc: ioc
                },
            })
        }

        this.multipleWin = (data) => {
            data.redirect = "MultipleWin"

            this.doRedirect(data)
            startIdleTimer()
        }

        this.winPrizeDetail = (data) => {
            data.redirect = "WinPrizeDetail"

            this.doRedirect(data)
        }

        this.errorPage = (data) => {
            data.redirect = "ErrorPage"
            
            this.doRedirect(data)
        }

        this.gameLoaded = () => {
            // setChiGameLoaded(true)
            window.dispatchEvent( new Event('game.loaded') );
            startIdleTimer()
        }

        this.next = (data) => {
            Device.unlock("WM.next", data.systemId)
            this.doRedirect("next")
        }
        
        this.prev = (data) => {
            Device.unlock("WM.prev", data.systemId)
            this.doRedirect("prev")
        }
        
        this.goTo = (data, param) => {
            Device.unlock("WM.goTo", { systemId : data.systemId, to: param})
            throw new Error("Unable to navigate tactics in STA")
        }

        let startIdleTimer = () => {
            let self = this
            let time = getParameterByName("idleTimeout")
            if(time){
                let idleTimeout = _.get(settings, "globals.idleTimeout", {})

                idleTimeoutTimer = setTimeout(function(){
                    self.errorPage({
                        title: idleTimeout.title || "Timeout",
                        errorMsg: idleTimeout.errorMsg || "No error description is provided"
                    })
                }, time)
            }
        }
    }

    if (isNode) {
        module.exports = {
            GameNavigation: GameNavigation
        }
    } else {
        root.GameNavigation = GameNavigation
    }
})()